import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Grid,
} from "@mui/material";

import { Add, Search } from "@mui/icons-material";
import { format, subDays } from "date-fns";
import Colors from "../../constants/Colors";
import VisitSearchCard from "../../components/cards/visits/VisitSearchCard";

const VisitsPage = (): JSX.Element => {
  const navigate = useNavigate();
  const [initialEmissionError, setInitialEmissionError] = useState(false);
  const [finalEmissionError, setFinalEmissionError] = useState(false);

  const [visitSearchParams, setVisitSearchParams] = useState<any>(() => {
    const saved = localStorage.getItem("visitSearchParams");
    let params: any = {};
    if (saved) {
      try {
        params = JSON.parse(saved);
      } catch (e) {}
    }

    const today = new Date();
    if (!params.emissaoInicial) {
      params.emissaoInicial = format(subDays(today, 7), "dd/MM/yyyy");
    }
    if (!params.emissaoFinal) {
      params.emissaoFinal = format(today, "dd/MM/yyyy");
    }

    return params;
  });

  const navigateToSearch = () => {
    if (initialEmissionError || finalEmissionError) return;
    localStorage.setItem(
      "visitSearchParams",
      JSON.stringify(visitSearchParams),
    );
    navigate("/visitas/pesquisar");
  };

  return (
    <>
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        width={"100%"}
        sx={{ pb: 8 }} // padding for bottom menu
      >
        <Grid
          container
          mt={{ md: 1, xs: 1 }}
          spacing={1}
          justifyContent={"center"}
          alignItems={"center"}
          width={{
            md: "40%",
            xs: "95%",
          }}
        >
          <VisitSearchCard
            finalEmissionError={finalEmissionError}
            inicialEmissionError={initialEmissionError}
            toggleInicialEmissionError={(errorValue: boolean) =>
              setInitialEmissionError(errorValue)
            }
            toggleFinalEmissionError={(errorValue: boolean) =>
              setFinalEmissionError(errorValue)
            }
            visitSearchParams={visitSearchParams}
            setVisitSearchParams={setVisitSearchParams}
          />
        </Grid>
      </Grid>
      <Paper
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
        elevation={3}
      >
        <BottomNavigation showLabels>
          <BottomNavigationAction
            sx={{ color: Colors.primary }}
            label="Pesquisar"
            icon={<Search />}
            onClick={() => navigateToSearch()}
          />
          <BottomNavigationAction
            sx={{ color: Colors.primary }}
            label="Novo"
            icon={<Add />}
            onClick={() => navigate("/visitas/criar")}
          />
        </BottomNavigation>
      </Paper>
    </>
  );
};

export default VisitsPage;
